// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v7.35.1
// source: future.proto

/* eslint-disable */
import * as _m0 from "protobufjs/minimal";
import { Expiry } from "./common";
import { Security } from "./security";

export const protobufPackage = "com.tick2trade.api.future";

export interface FutureSecurity {
  security: Security | undefined;
  expiry: Expiry | undefined;
  derived: boolean;
}

export interface FutureSecurities {
  security: Security | undefined;
  futureSecurities: FutureSecurity[];
}

function createBaseFutureSecurity(): FutureSecurity {
  return { security: undefined, expiry: undefined, derived: false };
}

export const FutureSecurity = {
  encode(message: FutureSecurity, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.security !== undefined) {
      Security.encode(message.security, writer.uint32(10).fork()).ldelim();
    }
    if (message.expiry !== undefined) {
      Expiry.encode(message.expiry, writer.uint32(18).fork()).ldelim();
    }
    if (message.derived !== false) {
      writer.uint32(24).bool(message.derived);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): FutureSecurity {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFutureSecurity();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.security = Security.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.expiry = Expiry.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.derived = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FutureSecurity {
    return {
      security: isSet(object.security) ? Security.fromJSON(object.security) : undefined,
      expiry: isSet(object.expiry) ? Expiry.fromJSON(object.expiry) : undefined,
      derived: isSet(object.derived) ? globalThis.Boolean(object.derived) : false,
    };
  },

  toJSON(message: FutureSecurity): unknown {
    const obj: any = {};
    if (message.security !== undefined) {
      obj.security = Security.toJSON(message.security);
    }
    if (message.expiry !== undefined) {
      obj.expiry = Expiry.toJSON(message.expiry);
    }
    if (message.derived !== false) {
      obj.derived = message.derived;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FutureSecurity>, I>>(base?: I): FutureSecurity {
    return FutureSecurity.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FutureSecurity>, I>>(object: I): FutureSecurity {
    const message = createBaseFutureSecurity();
    message.security = (object.security !== undefined && object.security !== null)
      ? Security.fromPartial(object.security)
      : undefined;
    message.expiry = (object.expiry !== undefined && object.expiry !== null)
      ? Expiry.fromPartial(object.expiry)
      : undefined;
    message.derived = object.derived ?? false;
    return message;
  },
};

function createBaseFutureSecurities(): FutureSecurities {
  return { security: undefined, futureSecurities: [] };
}

export const FutureSecurities = {
  encode(message: FutureSecurities, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.security !== undefined) {
      Security.encode(message.security, writer.uint32(10).fork()).ldelim();
    }
    for (const v of message.futureSecurities) {
      FutureSecurity.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): FutureSecurities {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFutureSecurities();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.security = Security.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.futureSecurities.push(FutureSecurity.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FutureSecurities {
    return {
      security: isSet(object.security) ? Security.fromJSON(object.security) : undefined,
      futureSecurities: globalThis.Array.isArray(object?.futureSecurities)
        ? object.futureSecurities.map((e: any) => FutureSecurity.fromJSON(e))
        : [],
    };
  },

  toJSON(message: FutureSecurities): unknown {
    const obj: any = {};
    if (message.security !== undefined) {
      obj.security = Security.toJSON(message.security);
    }
    if (message.futureSecurities?.length) {
      obj.futureSecurities = message.futureSecurities.map((e) => FutureSecurity.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FutureSecurities>, I>>(base?: I): FutureSecurities {
    return FutureSecurities.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FutureSecurities>, I>>(object: I): FutureSecurities {
    const message = createBaseFutureSecurities();
    message.security = (object.security !== undefined && object.security !== null)
      ? Security.fromPartial(object.security)
      : undefined;
    message.futureSecurities = object.futureSecurities?.map((e) => FutureSecurity.fromPartial(e)) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
